<template>
  <div
    class="h-header-box"
    :class="{
      hideShadow: isInTelegramWebApp,
      telegramWebApp: isInTelegramWebApp,
    }"
    :style="customStyle"
  >
    <div class="logo-box">
      <div
        v-if="isHome && topNavigationTemplate && topNavigationTemplate.menuPosition === 1 && !isInTelegramWebApp"
        class="menu-icon left"
        :class="{
          'is-reverse': menuIsShow,
        }"
        @click="menuClick"
        v-exposure="{ eid: `101_0_0_127` }"
        :data-id="`101_0_0_127`"
      >
        <img :src="celanbtn" fit="contain" alt />
      </div>

      <div
        v-if="isHome || isMenu || isTg || isInTelegramWebApp"
        :class="{
          tg: isInTelegramWebApp,
        }"
        class="logo"
        @click="toLink('/home')"
      >
        <img v-if="logo" class="logo-img" :src="logo" fit="contain" alt />
      </div>

      <div
        v-if="!isHome && !isMenu && !isTg && !isInTelegramWebApp"
        class="retuenBtn"
        @click="goBackPage"
        :style="`height: ${$px2rem(40)}`"
      >
        <img
          v-if="fanhuibtn"
          style="width: 22px; height: 22px; margin-top: 9px; pointer-events: none"
          :src="fanhuibtn"
          fit="contain"
          alt
        />
      </div>
    </div>

    <div class="login-btn-wrap" v-if="!isLogin && !isInTelegramWebApp">
      <div
        class="login-btn"
        v-for="(item, i) in menuItems"
        :key="i"
        @click="clickFun(item.value, item.eid)"
        v-exposure="{ eid: item.eid }"
        :data-id="item.eid"
      >
        {{ item.title }}
      </div>
      <el-dropdown v-if="!isTgApp" trigger="click" placement="bottom-start" class="lang-dropdown" @command="changeFun">
        <img class="cur-lang-icon-new" :src="getlangIcon" alt />
        <el-dropdown-menu slot="dropdown" :style="computeStyle">
          <el-dropdown-item v-for="item in locales" :key="item.locale" :command="item.locale">
            <div class="lang-row-wrap">
              <img v-lazy="item.icon" class="language-icon" alt />
              <span class="language-title">{{ item.title }}</span>
            </div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div
        v-if="isHome && topNavigationTemplate && topNavigationTemplate.menuPosition === 2"
        class="menu-icon right"
        @click="menuClick"
        v-exposure="{ eid: `101_0_0_127` }"
        :data-id="`101_0_0_127`"
      >
        <img :src="celanbtn" fit="contain" alt />
      </div>
      <img
        v-if="showSeachIcon"
        class="search_icon"
        @click="clickSearch"
        :src="require(`@/assets/user/search.png`)"
        alt
      />
      <emailIcon v-if="showEmailIcon" class="email_icon" />
      <img
        v-if="showUserCenterIcon"
        class="userCenter_icon"
        @click="clickUserCenter"
        :src="require(`@/assets/home/user.png`)"
        alt
      />
    </div>
    <div class="head-user-info box-flex" v-else-if="taken">
      <div class="c-info">
        <div id="vStep" class="godVip-box" v-exposure="{ eid: `101_0_0_129` }" :data-id="`101_0_0_129`">
          <el-dropdown
            @command="handleCheck"
            ref="messageDrop"
            trigger="click"
            @click.native="dropdown"
            @visible-change="visibleChange"
            :hide-on-click="true"
            :disabled="
              !!isGame() ||
              getAppConfig.withdrawMode === 'WITHDRAW_MODE_LIMIT' ||
              getAppConfig.withdrawMode === 'WITHDRAW_MODE_CLOSE' ||
              isInTelegramWebApp
            "
          >
            <!-- 单一货币展示 -->
            <div v-if="coinStyle === 2" class="el-dropdown-link el-dropdown-link1" style="position: relative">
              <div>
                <div class="flex font12">
                  <img :src="$utils.returnImgUrl(curCoin.coinIcon)" alt />
                  <span v-if="!isInTelegramWebApp">{{ curCoin.symbol }}</span>
                  <span v-if="!!isGame()">{{
                    isInTelegramWebApp
                      ? $t("Datalang.HomePage_TITLE_ingaming")
                      : `（${$t("Datalang.HomePage_TITLE_ingaming")}）`
                  }}</span>
                  <span v-else>{{ divideSymbol(curCoin.chips, curCoin.accuracy) }}</span>
                </div>
                <div v-if="Number(curCoin.experience) > 0" class="flex font12">
                  <img :src="$utils.returnImgUrl(curCoin.freeIcon || curCoin.coinIcon)" alt />
                  <span v-if="!isInTelegramWebApp">{{ curCoin.freeSymbol || curCoin.symbol }}</span>
                  <span v-if="!!isGame()">{{
                    isInTelegramWebApp
                      ? $t("Datalang.HomePage_TITLE_ingaming")
                      : `（${$t("Datalang.HomePage_TITLE_ingaming")}）`
                  }}</span>
                  <span v-else>{{ divideSymbol(curCoin.experience, curCoin.accuracy) }}</span>
                </div>
              </div>
              <i
                v-if="
                  getAppConfig.withdrawMode !== 'WITHDRAW_MODE_LIMIT' &&
                  getAppConfig.withdrawMode !== 'WITHDRAW_MODE_CLOSE' &&
                  !isInTelegramWebApp
                "
                class="el-icon-arrow-down"
                :class="{
                  'is-reverse': boxVisible,
                }"
                style="margin-left: 5px; font-weight: bold"
              ></i>
            </div>
            <!-- 多货币 -->
            <label v-else class="el-dropdown-link" style="position: relative">
              <img v-show="curCoin.coinIcon" :src="$utils.returnImgUrl(curCoin.coinIcon)" alt />
              <span v-if="!isInTelegramWebApp">{{ curCoin.symbol }}</span>
              <span v-if="!!isGame()">{{
                isInTelegramWebApp
                  ? $t("Datalang.HomePage_TITLE_ingaming")
                  : `（${$t("Datalang.HomePage_TITLE_ingaming")}）`
              }}</span>
              <span v-else>{{ divideSymbol(curCoin.allChips, curCoin.accuracy) }}</span>
              <i
                v-if="
                  getAppConfig.withdrawMode !== 'WITHDRAW_MODE_LIMIT' &&
                  getAppConfig.withdrawMode !== 'WITHDRAW_MODE_CLOSE' &&
                  !isInTelegramWebApp
                "
                class="el-icon-arrow-down"
                :class="{
                  'is-reverse': boxVisible,
                }"
                style="margin-left: 5px; font-weight: bold"
              ></i>
            </label>
            <el-dropdown-menu slot="dropdown" :style="computeStyle2">
              <template v-if="coinStyle === 2">
                <el-dropdown-item class="qbMode">
                  <div class="qbModeMain">
                    <div class="qbModeMainTop">
                      <div>{{ $t("Datalang.home_deposit_balance") }}</div>
                      <span class="el-icon-question" @click.stop="onShowInfoModal(3, 1)"></span>
                    </div>
                    <div class="qbModeMainCon">
                      <div class="amount">{{ UserCoins[0]?.symbol + " " + divideSymbol(UserCoins[0]?.chips) }}</div>
                      <div class="qbModeMainConRight">
                        <div></div>
                        <div class="btn" @click.stop="goWithdraw(1)" align="center">
                          {{ $t("Datalang.Menu_BTM_withdraw") }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="qbModeMain mt10" v-if="UserCoins[0]?.experience > 0">
                    <div class="qbModeMainTop">
                      <div>{{ $t("Datalang.home_exprience") }}</div>
                      <span class="el-icon-question" @click.stop="onShowInfoModal(3, 2)"></span>
                    </div>
                    <div class="qbModeMainCon">
                      <div class="amount">
                        {{
                          (UserCoins[0]?.freeSymbol || UserCoins[0]?.symbol) +
                          " " +
                          divideSymbol(UserCoins[0]?.experience)
                        }}
                      </div>
                      <div class="qbModeMainConRight">
                        <div></div>
                        <div class="btn" @click.stop="goWithdraw(2)" align="center">{{ getBtnTxt() }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="qbModeMain mt10" v-if="hasCommissionWallet">
                    <div class="qbModeMainTop">
                      <div>{{ $t("Datalang.Home_Commission_Balance5") }}</div>
                      <span class="el-icon-question" @click.stop="onShowInfoModal(3, 3)"></span>
                    </div>
                    <div class="qbModeMainCon">
                      <div class="amount">
                        {{ UserCoins[0]?.symbol + " " + divideSymbol(UserCoins[0]?.commission) }}
                      </div>
                      <div class="qbModeMainConRight">
                        <div class="btn mr10" @click.stop="goHandleChange(UserCoins[0]?.coinCode)" align="center">
                          {{ $t("Datalang.Transfer_to_ACCOUNT") }}
                        </div>
                        <div class="btn" @click.stop="goWithdraw(3)" align="center">
                          {{ $t("Datalang.Menu_BTM_withdraw") }}
                        </div>
                      </div>
                    </div>
                  </div>
                </el-dropdown-item>
              </template>
              <template v-else>
                <el-dropdown-item class="qbHeaer">
                  <div align="left">
                    {{ $t("Datalang.Wallet_BTM_selectdefaultwallet") }}
                    <span v-if="rateList.length > 0" class="el-icon-question" @click="onShowInfoModal(1)"></span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item
                  v-for="(item, i) in UserCoins"
                  :command="item.coinCode"
                  :key="i"
                  class="qbItem"
                  :disabled="curCoin.coinCode === item.coinCode"
                >
                  <div class="qbDiv" v-if="isTgAppCoinCode(item)">
                    <img :src="$utils.returnImgUrl(item.coinIcon)" alt />
                    <span v-if="item.isExperienceCoinCode">{{ $t("Datalang.home_exprience") }}&nbsp;&nbsp;</span>
                    <span v-else>{{ item.coinCode }}&nbsp;&nbsp;</span>
                    <div class="chips">
                      <div class="symbol_coin">
                        {{ divideSymbol(item.isExperienceCoinCode ? item.experience : item.chips) }}
                      </div>
                    </div>
                  </div>
                  <div class="experienceDiv" v-if="item.isExperienceCoinCode">
                    <ExperienceWallet :experienceObj="item" />
                  </div>
                </el-dropdown-item>
                <el-dropdown-item class="qbFooter">
                  <span class="walletBtn" :class="{ first: isFirst }" @click="toWallet" align="center">
                    {{ $t("Datalang.Wallet_BTM_walletdetails") }}
                  </span>
                </el-dropdown-item>
              </template>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- 自定义提示 -->
          <!-- <div v-if="isShowTip" class="dropdown-tip">{{ `${curCoin.freeSymbol || curCoin.symbol} ${$t("Datalang.home_withdraw_now")}` }}<span class="dropdown-tip-arrow"></span></div> -->
        </div>
      </div>
      <!-- <span class="kefu" @click="onLinkService">
        <img src="@/assets/user/kefu_icon.png" alt />
      </span> -->
      <div
        v-if="!isInTelegramWebApp"
        class="login-btn recharge"
        @click="toRecharge"
        v-exposure="{ eid: `101_0_0_130` }"
        :data-id="`101_0_0_130`"
      >
        <i class="el-icon-plus"></i>
      </div>

      <div
        v-if="isHome && topNavigationTemplate && topNavigationTemplate.menuPosition === 2"
        class="menu-icon right"
        @click="menuClick"
        v-exposure="{ eid: `101_0_0_127` }"
        :data-id="`101_0_0_127`"
      >
        <img :src="celanbtn" fit="contain" alt />
      </div>
      <img
        v-if="showSeachIcon"
        class="search_icon"
        @click="clickSearch"
        :src="require(`@/assets/user/search.png`)"
        alt
      />
      <emailIcon v-if="showEmailIcon" class="email_icon" />
      <img
        v-if="showUserCenterIcon"
        class="userCenter_icon"
        @click="clickUserCenter"
        :src="require(`@/assets/home/user.png`)"
        alt
      />
    </div>
    <PopupDialog
      id="hrate_modal"
      :fullscreen="true"
      ref="PopupDialog"
      :dataOpt="{
        title: getTitle(),
      }"
      :show.sync="PopupWindowShow"
      @close="closeFun"
    >
      <template #center>
        <div class="modal-info">
          <div v-if="infoType === 1">
            <p>1. {{ $t("Datalang.Wallet_TEXT_circulationcurrenc") }}</p>
            <template v-if="rateList.length">
              <div v-for="item in rateList" :key="item.id">
                1{{ item.fromCoin }} ≈ {{ item.rate }} {{ item.toCoin }}
              </div>
            </template>
            <p>2. {{ $t("Datalang.Wallet_TEXT_defaultwallet") }}</p>
          </div>
          <div v-if="infoType === 2">
            <p>{{ $t("Datalang.home_withdrawable") }}</p>
          </div>
          <div v-if="infoType === 3">
            <p>{{ getTxt() }}</p>
          </div>
          <div class="btn-content">
            <el-button round type="primary" @click="closeFun">{{ $t("Datalang.Withdrawl_TIP_getit") }}</el-button>
          </div>
        </div>
      </template>
    </PopupDialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import fanhuibtn from "@/assets/chage/Back_btn.png";
import celanbtn from "@/assets/home/celan_btn.png";
// import Jb from "@/assets/img/jb.png";
// import UserIcon from "@/assets/img/txk.png";
import { divideAccuracy, divideSymbol, isGame, isInTelegramWebApp } from "@/lobby_common/utils/utils.js";
import { killPlayerUser } from "@/lobby_common/api/game_gen";
import { selectWallet } from "@/lobby_common/api/user_gen";
import {
  getCoinExchangeRateData,
  getTxtFun,
  goWithdrawFun,
  getBtnTxtFun,
  goHandleChangeFun,
} from "@/lobby_common/utils/utils.js";
import PopupDialog from "@/components/PopupDialog";
import { setLocale } from "@/lobby_common/locale";
import { updateUserLanguage } from "@/lobby_common/api/user_gen.js";
import { cacheKeys } from "@/lobby_common/utils/commonEnum.js";
import { bigAdd } from "@/lobby_common/utils/big.js";
import ExperienceWallet from "@/components/experienceWallet/index.vue";
import emailIcon from "@/lobby_common/mixins_components/emailIcon/index.vue";
import { clearAllDB } from "@/lobby_common/utils/jsonCache.js";
export default {
  name: "h-header",
  components: { PopupDialog, ExperienceWallet, emailIcon },
  props: ["isMenu", "isTg", "customStyle"],
  data() {
    return {
      bigAdd,
      killPlayerUser,
      setLocale,
      fanhuibtn,
      celanbtn,
      // Jb,
      // UserIcon,
      divideAccuracy,
      divideSymbol,
      // curCoin: {},
      obj: {},
      UserCoins: [],
      PopupWindowShow: false,
      // rateList: [],
      isFirst: false,
      isHome: true,
      isGame: isGame,
      isApi: false,
      cacheKeys,
      boxVisible: false,
      infoType: 1,
      walletTypeTxt: 1,
      // rateLoading: false,
      // coinExchangeRate: [],
    };
  },
  watch: {
    getUserCoins: {
      handler: function () {
        this.handeleUserCoins();
      },
      deep: true,
      immediate: true,
    },
    "$route.params": {
      handler(newval, oldval) {
        if (this.$route.path === "/home") {
          this.isHome = true;
        } else {
          this.isHome = false;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  async created() {},
  computed: {
    hasCommissionWallet() {
      const obj = this.$store.getters.getPacketConfig?.appConfig || {};
      const walletType = obj.wallets || [];
      return walletType.includes("COMMISSION_WALLET");
    },
    computeStyle() {
      return `max-height: 500px; padding-bottom: ${this.isMobile ? "8px" : "22px"};overflow: auto`;
    },
    computeStyle2() {
      if (this.hasExperienceWallet && this.coinStyle !== 2) {
        return `max-height: ${this.$px2rem(300)};padding-bottom:${this.$px2rem(32)};overflow: auto`;
      }
      return `max-height: ${this.$px2rem(300)};padding-bottom:${this.$px2rem(12)};overflow: auto`;
    },
    getAppConfig() {
      return this.$store.getters.getPacketConfig?.appConfig || {};
    },
    topNavigationTemplateObj() {
      return this.$store.getters.getPacketConfig?.topNavigationTemplate || {};
    },
    coinStyle() {
      return Number(this.topNavigationTemplateObj.coinStyle);
    },
    topNavigationTemplate() {
      return this.$store.getters.getPacketConfig?.topNavigationTemplate?.h5 || null;
    },
    getlangIcon() {
      const arr =
        this.locales.filter((v) => {
          return v.locale === this.langSelect;
        }) || [];
      return arr[0] ? arr[0].icon : "";
    },
    locales() {
      return this.$store.getters.getLocalesList;
    },
    langSelect() {
      return this.$store.getters.getLang;
    },
    getData() {
      return this.$store.getters.getData;
    },
    getUserCoins() {
      return this.$store.getters.getUserCoins;
    },
    curCoin() {
      return this.$store.getters.getCurCoin || {};
    },
    rateList() {
      return this.$store.getters.getRateList || [];
    },
    coinExchangeRate() {
      return this.$store.getters.getCoinExchangeRate || [];
    },
    rateLoading() {
      return this.$store.getters.getRateLoading;
    },
    coinSymbol() {
      return this.$store.getters.user?.coin_symbol;
    },
    logo() {
      return this.$utils.returnImgUrl(this.$store.getters.getPacketConfig?.site?.indexLogo);
    },
    isLogin() {
      return this.$store.getters.login;
    },
    userData() {
      return this.$store.getters.user;
    },
    activityshowdata() {
      return this.$store.getters.activityshow;
    },
    ...mapGetters(["menuIsShow"]),
    menuItems() {
      const items = [
        {
          title: this.$t("Datalang.promotion_TITLE_Login"),
          type: "primary",
          value: 0,
          eid: `101_0_0_142`,
        },
        {
          title: this.$t("Datalang.promotion_TITLE_Register"),
          type: "primary",
          value: 1,
          eid: `101_0_0_143`,
        },
      ];
      return items;
    },
    taken() {
      return this.$store.getters.taken;
    },
    isMobile() {
      return this.$store.getters.getIsMobile;
    },
    userInfo() {
      return JSON.parse(JSON.stringify(this.$store.getters.user));
    },
    defaultCoinCode() {
      return this.userInfo.coinCode;
    },
    // 是否有体验彩金钱包
    hasExperienceWallet() {
      return this.getAppConfig?.wallets?.includes("EXPERIENCE_WALLET") || false;
    },
    showSeachIcon() {
      return (
        this.$store.getters.getPacketConfig?.topNavigationTemplate?.h5?.rightShow ===
        "TOP_NAVIGATION_TEMPLATE_RIGHT_SHOW_SEARCH"
      );
    },
    showEmailIcon() {
      return (
        this.$store.getters.getPacketConfig?.topNavigationTemplate?.h5?.rightShow ===
        "TOP_NAVIGATION_TEMPLATE_RIGHT_SHOW_EMAIL"
      );
    },
    showUserCenterIcon() {
      return (
        this.$store.getters.getPacketConfig?.topNavigationTemplate?.h5?.rightShow ===
        "TOP_NAVIGATION_TEMPLATE_RIGHT_PERSONAL_CENTER"
      );
    },
    isNewWithdrawMode() {
      const withdrawMode = this.getAppConfig.withdrawMode;
      return withdrawMode === "WITHDRAW_MODE_FREE_GOLD";
    },
    isShowTip() {
      const promptFreeGoldWithdraw = this.getAppConfig.promptFreeGoldWithdraw
        ? Number(this.getAppConfig.promptFreeGoldWithdraw)
        : 0;
      return (
        this.isNewWithdrawMode &&
        promptFreeGoldWithdraw !== 0 &&
        Number(this.curCoin.experience) > promptFreeGoldWithdraw
      );
    },
  },
  methods: {
    ...mapActions(["setMenuBar"]),
    clickSearch() {
      this.$eventPost("click", {
        eid: `101_0_0_128`,
        time: Date.now(),
      });
      this.$Bus.$emit("changeSearchDrawer");
    },
    clickUserCenter() {
      const path = this.isMobile ? "/userCenter" : "/user";
      this.$router.push(path);
    },
    async changeFun(val) {
      await clearAllDB();
      let code = 0;
      if (this.$store.getters.taken) {
        const res = (await updateUserLanguage({ language: val })) || {};
        code = res.code;
      }
      if (code === 0) {
        this.setLocale(val);
        this.$router.push("/home");
        // this.$Bus.$emit("reload")
        setTimeout(() => {
          window.location.reload();
        }, 100);
      }
    },
    handeleUserCoins() {
      const obj = this.getUserCoins;
      const data = { ...obj };
      const wallets = data.wallets || [];
      if (wallets.length === 0) {
        return false;
      }
      let UserCoins = [...wallets];
      // if (this.isTgApp) {
      //   UserCoins = UserCoins.map((t) => {
      //     if (["TON", "USDT"].includes(t.coinCode)) {
      //       return t;
      //     }
      //   });
      // }

      // 当前选中的币种
      UserCoins = UserCoins.map((v) => {
        // 充值 可提 彩金
        v.chips = this.divideAccuracy(
          Number(v.rechargeWallet) + Number(v.withdrawWallet) + Number(v.bonusWallet),
          v.accuracy
        );
        // 充值 可提 彩金 免费彩金
        v.allChips = this.divideAccuracy(
          Number(v.rechargeWallet) + Number(v.withdrawWallet) + Number(v.bonusWallet) + Number(v.experienceWallet),
          v.accuracy
        );
        v.isDefaultCoin = v.coinCode === this.defaultCoinCode; // 当前货币是否为会员货币
        // 体验彩金
        v.experience = this.hasExperienceWallet ? this.divideAccuracy(Number(v.experienceWallet), v.accuracy) : 0;
        // 佣金余额
        v.commission = Number(v.commissionWallet) ? this.divideAccuracy(Number(v.commissionWallet), v.accuracy) : 0;
        return { ...v };
      });
      // 当前选中的币种
      const selectedCoinCode = data.selectedCoinCode || UserCoins[0]?.coinCode;

      console.log(UserCoins, "UserCoins");

      this.$set(this, "UserCoins", UserCoins);
      if (!this.rateList.length) {
        this.getRateList(data);
      }
      this.afterGetCoincode(selectedCoinCode);
    },
    menuClick() {
      this.$eventPost("click", {
        eid: `101_0_0_127`,
        time: Date.now(),
      });
      console.log("this.menuIsShow", this.menuIsShow);
      this.setMenuBar(!this.menuIsShow);
    },
    visibleChange(val) {
      if (val) {
        // console.log(val);
        const flag = localStorage.getItem("firstVisit");
        // console.log(flag, "flag");
        this.isFirst = !flag;
        // this.$refs.messageDrop.visible = false;
      }
      this.boxVisible = val;
    },
    async onShowInfoModal(type, walletTypeTxt) {
      this.infoType = type;
      this.walletTypeTxt = walletTypeTxt || 1;
      this.PopupWindowShow = true;
    },
    getTitle() {
      if (this.infoType === 1) {
        return this.$t("Datalang.Wallet_BTM_switchwalletdescription");
      }
      if (this.infoType === 2) {
        return this.$t("Datalang.home_exprience");
      }
      if (this.infoType === 3) {
        return this.$t("Datalang.Recharge_TIP_tip");
      }
    },
    getTxt() {
      const walletTypeTxt = this.walletTypeTxt; // 1真实钱包  2免费金币钱包  3佣金钱包
      return getTxtFun(walletTypeTxt);
    },
    goWithdraw(type) {
      const msg = [
        "",
        "currency_display_cash_withdraw",
        "currency_display_free_coin_withdraw",
        "currency_commission_withdraw",
      ];
      this.$eventPost(msg[type]);
      goWithdrawFun(type);
    },
    getBtnTxt() {
      return getBtnTxtFun();
    },
    goHandleChange(coinCode) {
      goHandleChangeFun(coinCode);
    },
    closeFun() {
      this.PopupWindowShow = false;
    },

    async getRateList(coinList = {}) {
      // 共用汇率loading，只请求一次汇率接口
      if (this.rateLoading) return;
      this.$store.commit("setRateLoading", true);
      const arr = coinList.wallets || [];
      const checkedCoin = arr.find((item) => item.coinCode === coinList.selectedCoinCode) || {};
      let dataList = [];
      if (this.coinExchangeRate.length) {
        dataList = this.coinExchangeRate;
      } else {
        const { code, data } = await getCoinExchangeRateData();
        if (code === 0) {
          dataList = data.list || [];
          // 存汇率表
          this.$store.commit("setCoinExchangeRate", dataList);
        }
      }
      const walletCoin = arr.map((item) => item.coinCode) || [];
      const brr = dataList.filter((item) => item.toCoin === checkedCoin.coinCode) || [];
      const _arr = brr.filter((item) => walletCoin.includes(item.fromCoin)) || [];
      // 存当前货币汇率数据
      this.$store.commit("setRateList", _arr);
      this.$store.commit("setRateLoading", false);
    },
    // 前往钱包
    toWallet() {
      if (this.isMenu) {
        this.setMenuBar(false);
      }
      this.$router.push("/user/hWallet");
    },
    afterGetCoincode(command) {
      if (!command) return false;
      // const { code } = await this.killPlayerUser({});
      // if (code !== 0) {
      //   return;
      // }
      const arr = this.UserCoins.filter((v) => {
        return v.coinCode === command;
      });
      if (arr && arr.length) {
        this.$store.commit("setCurCoin", arr[0]);
      }
      localStorage.setItem("coinCode", command);
      // localStorage.setItem("Cur_Chips", this.curCoin.chips);
      localStorage.setItem(
        "Cur_Chips",
        this.curCoin.isExperienceCoinCode ? this.curCoin.experience : this.curCoin.chips
      );

      this.$store.commit("setSelectCoin", command);
    },
    // 跳转充值
    toCharge() {
      const opt = {
        // icon: charge,
        label: this.$t("route.charge"),
        width: "36px",
        path: "Charge",
        id: 10020017,
      };
      const whiteList = ["Charge", "Exchange", "Vip"];
      const titleStr = {
        Charge: this.$t("route.charge"),
        Exchange: this.$t("route.exchange"),
      };
      if (whiteList.includes(opt.path)) {
        if (this.taken) {
          const title = titleStr[opt.path] || null;
          this.$isPopShow({
            show: true,
            views: opt.path,
            data: {
              title: title,
            },
          });
        } else {
          this.$Bus.$emit("showLogin");
        }
      } else {
        this.$router.push(opt.path || "/");
      }
    },
    dropdown() {
      if (this.$refs.messageDrop.visible === true) {
        this.$refs.messageDrop.visible = false;
      } else {
        this.$eventPost("currency_display_click");
        this.$refs.messageDrop.visible = true;
      }
    },
    async handleCheck(val) {
      console.log(val);
      //   this.dropdown();
      // this.handleCheckCoinCode(val);
      if (!val) return false;
      if (val.includes("experience")) return false;
      const { code } = await this.killPlayerUser({});
      if (code !== 0) {
        return;
      }
      const arr = this.UserCoins.filter((v) => {
        return v.coinCode === val;
      });
      if (arr && arr.length) {
        this.$store.commit("setCurCoin", arr[0]);
      }
      localStorage.setItem("coinCode", val);
      localStorage.setItem(
        "Cur_Chips",
        this.curCoin.isExperienceCoinCode ? this.curCoin.experience : this.curCoin.chips
      );
      this.$eventPost("click", {
        eid: `101_0_0_129`,
        coinCode: val,
        time: Date.now(),
      });
      selectWallet({ coinCode: val }).then((res) => {
        this.$store.commit("setSelectCoin", val);
        this.$store.dispatch("getUserInfo");
        if (isGame()) {
          // 在游戏中就刷新页面
          window.location.reload();
        }
        this.$Bus.$emit("reload");
      });
    },
    // 切换货币
    async handleCheckCoinCode(command, once = false) {
      if (!command) return false;
      // const { code } = await this.killPlayerUser({});
      // if (code !== 0) {
      //   return;
      // }
      const arr = this.UserCoins.filter((v) => {
        return v.coinCode === command;
      });
      if (arr && arr.length) {
        this.$store.commit("setCurCoin", arr[0]);
      }
      localStorage.setItem("coinCode", command);
      localStorage.setItem(
        "Cur_Chips",
        this.curCoin.isExperienceCoinCode ? this.curCoin.experience : this.curCoin.chips
      );
      await selectWallet({ coinCode: command }).then((res) => {
        this.$store.commit("setSelectCoin", command);
        if (!once) {
          if (isGame()) {
            // 在游戏中就刷新页面
            window.location.reload();
          }
        }
      });
    },
    showWalletBalance(e) {
      this.$router.push("/hWallet/hWalletDetail");
    },
    clickFun(type, eid) {
      const objStr = {
        0: "Login",
        1: "Register",
      };
      this.$eventPost("click", {
        eid,
        time: Date.now(),
      });
      this.$Bus.$emit("showLogin", { show: true, tab: objStr[type] });
    },
    toLink(path) {
      // localStorage.setItem("after_quick", true);
      if (this.isMenu) {
        this.setMenuBar(false);
      }
      this.$router.push(path || "/");
    },
    goBackPage() {
      const url = window.location.href;
      console.log(url);
      if (url.includes("/rankPage")) {
        this.$eventPost("dama_rank_close");
      }
      const name = this.$route.name;
      if (name === "homeSearch" || this.cacheKeys.includes(name.slice(0, -1))) {
        this.$router.push("/home");
        return;
      }
      if (url.includes("/activityDetail/")) {
        window.history.back();
        return;
      }
      if (url.includes("/rewardInvite")) {
        this.$router.push("/home");
        return;
      }
      if (Number(this.$router.history?.current?.params?.canTestPlay) === "STATUS_BOOL_TRUE") {
        // 专业代进来的试玩，没有上层历史路由，直接返回首页
        this.$router.push("/home");
        return;
      }

      const isSelfStudy = this.$route.query?.brand || "";
      if (isSelfStudy === "2") {
        this.$router.push("/home");
      }
      if (this.$route.path === "/video") {
        this.$router.push("/home"); // 返回首页
      } else {
        // 判断是否有历史记录
        if (window.history.length > 1) {
          this.$router.go(-1); // 返回上一级
        } else {
          this.$router.push("/home"); // 返回首页
        }
      }

      // this.$router.go(-1);
    },
    onLinkService() {
      this.$router.push("/user/hCustomerService");
    },
    toRecharge() {
      this.$eventPost("click", {
        eid: `101_0_0_130`,
        time: Date.now(),
      });
      this.$Bus.$emit("showCharge", { show: true });
    },
  },
  activated() {},
};
</script>

<style>
ul.el-menu--horizontal .el-menu-item {
  font-size: 16px;
  margin: 0 20px;
  padding: 0 3px;
}
</style>
<style lang="scss" scoped>
body.black-theme .el-dropdown-menu.el-popper {
  max-height: 300px;
  overflow: auto;
}
#hrate_modal {
  .is-fullscreen {
    width: 100% !important;
  }
}

.el-dropdown.lang-dropdown {
  padding: 5px;
  margin-left: 10px;
}
.cur-lang-icon-new {
  width: 20px;
  height: 20px;
  display: block;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  cursor: pointer;
}
.lang-row-wrap {
  display: flex;
  align-items: center;

  .language-icon {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
}

.modal-info {
  word-break: break-word;

  div {
    line-height: 24px;
  }
}

.btn-content {
  display: flex;
  justify-content: center;
  .el-button {
    @include buttonYellow;
  }
}

.el-dropdown-menu.el-popper {
  padding: 0;

  .qbHeaer,
  .qbFooter {
    cursor: auto;
  }

  .qbHeaer {
    padding: 0 10px;
    margin: 0 10px;
  }

  .el-icon-question {
    cursor: pointer;
    margin-left: 5px;
  }

  .qbItem {
    margin-bottom: 2px;
    padding: 0 10px;
    margin: 0 10px;
    border-bottom: 1px solid var(--border-color-100);
    color: var(--font-color-100);
  }

  .is-disabled {
    color: var(--font-color-300) !important;
    pointer-events: auto;
  }

  .qbFooter {
    text-align: center;
    height: 36px;
    padding: 8px 0;

    .walletBtn {
      cursor: pointer;
      line-height: 24px;
      padding: 6px 20px;
      display: inline-block;
      overflow: hidden;
      position: relative;
      @include buttonPrimary;

      &.first {
        &:before {
          content: "";
          position: absolute;
          width: 200px;
          height: 30px;
          /**白光的宽度，可根据实际调整**/
          background-image: linear-gradient(to bottom, transparent, rgba(255, 255, 255, 0.5), transparent);
          -webkit-transform: rotate(-45deg);
          -moz-transform: rotate(-45deg);
          -ms-transform: rotate(-45deg);
          -o-transform: rotate(-45deg);
          transform: rotate(-45deg);
          -webkit-animation: searchLights 3s ease-in 1s infinite;
          -o-animation: searchLights 3s ease-in 1s infinite;
          animation: searchLights 3s ease-in 1s infinite;
          /**第一个数字参数控制扫光速度，数字越大越慢**/
        }

        @keyframes searchLights {
          0% {
            left: -120px;
            top: -20px;
          }

          100% {
            left: 100px;
            top: 100px;
          }
        }
      }
    }
  }
}

.qbDiv {
  position: relative;
  padding: 0 120px 0 25px;
  &.experienceWrap {
    margin-bottom: 20px;
  }
  .experience_coin {
    line-height: 1;
    font-size: 12px;
    color: var(--font-color-1800);
    .el-icon-question {
      pointer-events: all;
      cursor: pointer;
      margin-left: 5px;
      font-size: 14px;
      color: var(--font-color-200);
    }
  }

  img {
    position: absolute;
    width: 16px;
    height: 16px;
    left: 0;
    top: 8.5px;
  }

  .chips {
    position: absolute;
    width: 120px;
    right: 0;
    top: 0;
    text-align: right;
  }
}

.symbol_coin {
  line-height: 36px;
  // padding-left: 35px;
}

.symbol_coin.symbol_coin1 {
  position: relative;
  line-height: 18px;

  .symbol_span {
    // position: absolute;
    left: 0;
    top: 0;
    width: 30px;
    text-align: right;
    padding-right: 5px;
  }
}

.h-header-box {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px;
  color: var(--font-color-200);
  // background: var(--background-200);
  // box-shadow: 0px 5px 20px 0px rgba(4, 0, 0, 0.35);
  box-shadow: var(--boxShadow-700);
  box-sizing: border-box;
  // overflow: hidden;
  &.hideShadow {
    box-shadow: none;
  }
  &.telegramWebApp {
    box-shadow: none;
    width: 58%;
    margin: 0 auto;
    margin-top: -2px;
  }
}

.box-flex {
  display: flex;
  text-align: center;
  justify-content: flex-start;
  align-items: center;
}

.menu-icon {
  width: 28px;
  cursor: pointer;
  transition: transform ease 0.3s;
  &.left {
    margin-right: 10px;
  }
  &.right {
    margin-left: 10px;
  }

  img {
    width: 100%;
    display: block;
  }
}

.logo-box {
  display: flex;
  align-items: center;

  .logo {
    height: 40px;
    overflow: hidden;
    display: flex;
    align-items: center;
    &-img {
      height: 30px;
      margin-top: 5px;
      pointer-events: none;
      @media (max-width: 380px) {
        height: 30px;
      }
    }
    &.tg {
      margin-left: 10px;
    }
  }

  .collapse-on-off {
    font-size: 1px;
    margin-right: 0px;
  }
}
.flex {
  display: flex;
  align-items: center;
  height: 17px;
}
.font12 {
  font-size: 12px;
}
.qbMode {
  background: var(--pulldown-100) !important;
  padding: 10px !important;
  .qbModeMain {
    min-width: 300px;
    .qbModeMainTop {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 30px;
      line-height: 30px;
      font-size: 13px;
      background: var(--background-400);
      padding: 0 10px;
      border-radius: 5px 5px 0 0;
    }
    .qbModeMainCon {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 50px;
      padding: 10px;
      box-sizing: border-box;
      background: var(--background-1502);
      border-radius: 0 0 5px 5px;
      .amount {
        font-size: 16px;
      }
      .qbModeMainConRight {
        display: flex;
        align-items: center;
        .btn {
          font-size: 12px;
          cursor: pointer;
          line-height: 24px;
          padding: 3px 10px;
          display: inline-block;
          overflow: hidden;
          position: relative;
          @include buttonPrimary;
        }
      }
    }
  }
}
.head-user-info {
  // justify-content: flex-start;
  justify-content: flex-end;

  ::v-deep .el-avatar {
    background-color: transparent;
  }

  .kefu {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    padding: 3px;
    margin-left: 10px;

    img {
      width: 25px;
    }
  }

  .godVip-box {
    .el-dropdown-link {
      min-width: 100px;
      height: 28px;
      line-height: 28px;
      font-size: 14px;
      padding: 8px;
      border-radius: var(--radius-200);
      box-sizing: border-box;
      color: var(--font-color-200);
      background: var(--background-700);
      overflow: hidden;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &.el-dropdown-link1 {
        height: 40px;
        line-height: 18px;
        img {
          width: 14px;
          height: 14px;
          margin-right: 4px;
        }
      }
      img {
        width: 18px;
        height: 18px;
        margin-right: 4px;
      }
    }
  }

  .chips-box {
    width: 100%;
    height: 32px;
    padding: 4px 8px;
    line-height: 22px;
    font-size: 14px;
    text-align: left;
    color: var(--font-color-100);
  }
}
</style>
<style lang="scss" scoped>
.dropdown-box {
  background-color: transparent !important;
  border: 1px solid transparent;

  ::v-deep .popper__arrow {
    border-bottom-color: transparent;

    &::after {
      border-bottom-color: rgba($color: var(--font-color-100), $alpha: 0.3);
    }
  }

  .el-dropdown-menu__item {
    width: 120px;
    max-width: 200px;
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    text-align: center;
    border-radius: 3px;
    margin-bottom: 3px;
  }
}

.login-btn-wrap {
  display: flex;
  align-items: center;
}
.login-btn {
  //min-width: 75px;
  padding: 0 8px;
  height: 28px;
  line-height: 28px;
  margin-left: 8px;
  font-size: 12px;
  text-align: center;
  max-width: 120px;
  overflow: hidden;
  &:nth-child(1) {
    color: var(--font-color-1401);
    // @include buttonPrimary;
  }

  &:nth-child(2) {
    @include buttonYellow;
  }

  &.recharge {
    min-width: 40px;
    @include buttonPrimary;
    display: flex;
    justify-content: center;
    align-items: center;
    .el-icon-plus:before {
      font-weight: bold;
      font-size: 19px;
      line-height: 28px;
    }
  }
}
.experienceDiv {
  padding-left: 25px;
  padding-bottom: 5px;
}
.search_icon {
  margin-left: 10px;
  width: 20px;
}
.email_icon {
  margin-left: 10px;
}
.userCenter_icon {
  margin-left: 10px;
  width: 28px;
}
#vStep {
  position: relative; /* 作为定位基准 */
  display: inline-block;
}

.dropdown-tip {
  position: absolute;
  top: 100%; /* 紧贴 dropdown 底部 */
  left: 50%; /* 水平居中 */
  transform: translateX(-50%);
  margin-top: 16px;
  padding: 4px 10px;
  background: var(--background-500);
  color: #fff;
  font-size: 12px;
  border-radius: 4px;
  white-space: nowrap;
  z-index: 10;
}

.dropdown-tip-arrow {
  position: absolute;
  top: -6px; /* 箭头顶到提示框 */
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid var(--background-500);
}
</style>
